module.exports = __webpack_public_path__ + "static/media/11.057122fb.jpg";